import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout.jsx'

export const Route = createFileRoute('/_auth/settings/tenant/config')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Layout.Body>
      <Outlet />
    </Layout.Body>
  )
}
